import React, { useEffect } from 'react';

export const TestWalkerWidget = () => {
  const init = () => {
    window.Planoplan.init({
      uid: '1234',
      el: 'test-widget',
    });
  };

  useEffect(() => {
    const script = document.createElement('script');

    script.src = `/static/test-widget/main.js?${Date.now()}`;
    script.async = true;
    script.onload = () => init();

    document.body.appendChild(script);
  }, []);

  return <div style={{ height: '100vh' }} id="test-widget" />;
};
